<script>
  import { format } from 'svelte-i18n';
  import { Input } from '@sveltestrap/sveltestrap';

  import { Icon } from '@client/components/icon';
  import { classnames } from '@client/utils/classnames';

  /**
   * Additional CSS classes for the input.
   * @type {string}
   */
  let className = '';
  export { className as class };

  /**
   * Bootstrap size to apply to the input.
   * @type {string | undefined}
   */
  export let bsSize = 'sm';

  /**
   * Determines whether the input is disabled.
   * @type {boolean | undefined}
   */
  export let disabled = undefined;

  /**
   * Feedback message for the Input.
   * @type {string | undefined}
   */
  export let feedback = undefined;

  /**
   * Inner content for the Input.
   * @type {HTMLElement | undefined}
   */
  export let inner = undefined;

  /**
   * Indicates whether the input is invalid.
   * @type {boolean}
   */
  export let invalid = false;

  /**
   * Name attribute for the Input.
   * @type {string}
   */
  export let name = '';

  /**
   * Placeholder text for the input.
   * @type {string}
   */
  export let placeholder = '';

  /**
   * Indicates whether the input is read-only.
   * @type {boolean | undefined}
   */
  export let readonly = undefined;

  /**
   * Determines the size of the input.
   * @type {number | undefined}
   */
  export let size = undefined;

  /**
   * Indicates whether the input is valid.
   * @type {boolean}
   */
  export let valid = false;

  /**
   * Value of the input.
   * @type {string | undefined}
   */
  export let value = undefined;

  /**
   * Computed CSS classes for the wrapper element.
   * @type {string}
   */
  $: classes = classnames(className, 'search-container');
</script>

<div class={classes}>
  <Icon name="search" class="position-absolute pe-none text-body-secondary" style="left: 12px; z-index: 2" />
  <Input
    class="rounded-pill"
    type="search"
    placeholder={placeholder || $format('label.SEARCH')}
    style="padding-left: 2rem"
    bind:value
    bind:inner
    on:blur
    on:change
    on:click
    on:dblclick
    on:focus
    on:input
    on:keydown
    on:keypress
    on:keyup
    on:mousedown
    on:mouseup
    {bsSize}
    {disabled}
    {feedback}
    {invalid}
    {name}
    {readonly}
    {size}
    {valid}
  />
</div>

<style lang="scss">
  .search-container {
    position: relative;
    display: flex;
    align-items: center;
  }
</style>
